import { motion } from 'motion/react';
import { useLocation, useNavigate } from 'react-router-dom';

import SidebarNavItem from './SidebarNavItem';

import { selectIsSidebarWide, useSidebarStore } from '@/shared/components/layout/_useSidebarStore';
import { SIDEBAR_WIDTH } from '@/shared/constants';

import type { SidebarMenuItem } from '@/shared/components/layout/types';

const panelVariants = {
  collapsed: { width: SIDEBAR_WIDTH.COLLAPSED },
  expanded: { width: SIDEBAR_WIDTH.EXPANDED },
};

/** 사이드바 네비게이션 아이템 컨테이너 */
export default function SidebarNavItemContainer({ menu }: { menu: SidebarMenuItem[] }) {
  const isSidebarWide = useSidebarStore(selectIsSidebarWide);
  const setSidebarExpanded = useSidebarStore((s) => s.setSidebarExpanded);
  const isMobileDrawerOpen = useSidebarStore((s) => s.isMobileDrawerOpen);

  // 라우터 구독은 여기 한 곳에서만 한다 — 각 행이 직접 구독하면 memo를 통과하지 못해
  // 쿼리 파라미터만 바뀌어도 메뉴 트리 전체가 리렌더된다.
  // pathname은 문자열, navigate는 데이터 라우터에서 참조가 고정되므로 둘 다 memo 비교를 통과한다.
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <motion.nav
      className='bg-basic-white border-r-table-line custom_scroll scroll_y_only absolute inset-0 z-50 flex flex-col items-center border-r pt-8'
      variants={panelVariants}
      initial='collapsed'
      animate={isSidebarWide ? 'expanded' : 'collapsed'}
      onHoverStart={() => {
        if (!isMobileDrawerOpen) setSidebarExpanded(true);
      }}
      onHoverEnd={() => {
        if (!isMobileDrawerOpen) setSidebarExpanded(false);
      }}>
      <ul className='flex w-full flex-col gap-2'>
        {menu?.map((menuItem, index) => (
          <li className='flex w-full flex-col' key={`${menuItem.id}-${index}`}>
            <SidebarNavItem menuItem={menuItem} pathname={pathname} navigate={navigate} />
          </li>
        ))}
      </ul>
    </motion.nav>
  );
}
